import { createContext, useEffect, useReducer } from "react"
import ClientReducer from "./ClientReducer";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const CLIENT_COOKIE_NAME = "ow-c";
const CLIENT_LOCALSTORAGE_KEY = "c";

// Retry wrapper for cookie reading - helps with timing issues after cross-domain redirects
const getCookieWithRetry = async (name, maxRetries = 5, delayMs = 100) => {
    for (let i = 0; i < maxRetries; i++) {
        const cookie = cookies.get(name);
        if (cookie) {
            console.log(`ClientContext - Cookie '${name}' found on attempt ${i + 1}`);
            return cookie;
        }
        if (i < maxRetries - 1) {
            console.log(`ClientContext - Cookie '${name}' not found, retrying (${i + 1}/${maxRetries})...`);
            await new Promise(resolve => setTimeout(resolve, delayMs));
        }
    }
    console.log(`ClientContext - Cookie '${name}' not found after ${maxRetries} attempts`);
    return null;
};

const CLIENT_INITIAL_STATE = {
    //client: JSON.parse(localStorage.getItem("c")) || null,
    client: cookies.get(CLIENT_COOKIE_NAME) || null,
    clientIsFetching: false,
    clientError: false
}

export const ClientContext = createContext(CLIENT_INITIAL_STATE);

export const ClientContextProvider = ({ children }) => {
    const [clientstate, clientdispatch] = useReducer(ClientReducer, CLIENT_INITIAL_STATE);

    // Initialize auth with retry logic to handle cross-domain redirect timing issues
    useEffect(() => {
        const initializeAuth = async () => {
            try {
                console.log('ClientContext - Attempting to read client cookie with retry...');
                let storedClient = await getCookieWithRetry(CLIENT_COOKIE_NAME);
                
                if (!storedClient) {
                    // Fallback to localStorage
                    const localClient = localStorage.getItem(CLIENT_LOCALSTORAGE_KEY);
                    if (localClient) {
                        try {
                            storedClient = JSON.parse(localClient);
                            console.log('ClientContext - Loaded client from localStorage');
                        } catch (e) {
                            console.error('ClientContext - Failed to parse localStorage client:', e);
                        }
                    }
                } else {
                    console.log('ClientContext - Loaded client from cookie');
                }

                // Update state if we found a client and it's different from current state
                if (storedClient && storedClient !== clientstate.client) {
                    clientdispatch({ type: "CLIENT_SUCCESS", payload: storedClient });
                }
            } catch (e) {
                console.error('ClientContext - Failed to initialize auth:', e);
            }
        };

        // Only run initialization if client is null (initial load or after redirect)
        if (!clientstate.client) {
            initializeAuth();
        }
    }, []); // Run only once on mount

    useEffect(() => {
        // console.log("COOKIE CLIENT : ",  cookies.get("ow-c"))
        // console.log("COOKIE CLIENT 2  : ",  clientstate.client)

        if (clientstate.client) {
            localStorage.setItem("c", JSON.stringify(clientstate.client));
            // cookies.set("ow-c", clientstate.client, {
            //     path: "/",
            //     expires: new Date(new Date().getTime() + 15 * 60 * 1000),
            //     domain: clientstate.client.domain,
            //     sameSite: "none",
            //     secure: true
            // })
             
        } else {
            console.log("REMOVE CLIENT")
            localStorage.removeItem("c");
            cookies.remove("ow-c") 
        }
    }, [clientstate.client]);


    return <ClientContext.Provider value={{
        client: clientstate.client,
        clientIsFetching: clientstate.clientIsFetching,
        clientError: clientstate.clientError,
        clientdispatch
    }}>{children}</ClientContext.Provider>

}